
// 检查是否为手机号
export function isPhoneNumber(val) { 
    let regular = /^1{1}\d{10}$/;
    return regular.test(val)
}



// 检查是否为邮箱号
export function isEmail(val) { 
    let regular = /^([a-zA-Z0-9_-]+)+(\.{1}[a-zA-Z0-9_-]+)?(\.{1}[a-zA-Z0-9_-]+)?@{1}[a-zA-Z0-9]+\.{1}[a-zA-Z]{2,4}(\.{1}[a-zA-Z]{2,4})?$/;
    return regular.test(val)
}




